// material-ui
import React, { ReactChild, useState } from "react";
import { Box, Divider, Drawer, Grid, IconButton, Typography } from "@mui/material";
import { ArchiveOutlined } from "@mui/icons-material";
import ModalDelete from "./ModalDelete";

// ==============================|| COMPONENTS - DRAWER ||============================== //

interface Props {
    open: boolean;
    title: string;
    caption: string;
    children: ReactChild;
    handleDrawerChangeState: () => void;
    isDeleteEnabled?: boolean;
    handleDrawerDeleteRecord?: () => void;
}

const DrawerViewEdit = ({
                            open,
                            title,
                            caption,
                            handleDrawerChangeState,
                            children,
                            handleDrawerDeleteRecord,
                            isDeleteEnabled
                        }: Props) => {

    // modal state
    const [openModal, setOpenModal] = useState<boolean>(false);
    const handleClose = () => {
        setOpenModal((prevState) => !prevState);
    };
    const handleAction = async () => {
        // @ts-ignore
        await handleDrawerDeleteRecord()
        setOpenModal((prevState) => !prevState);
        handleDrawerChangeState()
    };

    return (
        <>
            <Drawer
                sx={{
                    ml: open ? 3 : 0,
                    flexShrink: 0,
                    zIndex: 1200,
                    overflowX: 'hidden',
                    width: { xs: 320, md: 500 },
                    '& .MuiDrawer-paper': {
                        height: '100vh',
                        width: { xs: 320, md: 500 },
                        position: 'fixed',
                        border: 'none',
                        borderRadius: '0px'
                    }
                }}
                className={'fullscreen-enabled'}
                variant="temporary"
                anchor="right"
                open={open}
                ModalProps={{ keepMounted: true }}
                onClose={handleDrawerChangeState}
            >
                {open && (
                    <Box sx={{ p: 3 }}>
                        <Grid container spacing={4} mb={2} alignItems="center" justifyContent="space-between">
                            {!isDeleteEnabled && (
                                <Grid item>
                                    <Typography variant="h4">{title}</Typography>
                                    <Typography variant="caption">{caption}</Typography>
                                </Grid>
                            )}
                            {isDeleteEnabled && (
                                <>
                                    <Grid item>
                                        <Typography variant="h4">{title}</Typography>
                                    </Grid>
                                    <Grid item>
                                        <IconButton
                                            color="error"
                                            size="large"
                                            onClick={() => setOpenModal(true)}
                                        >
                                            <ArchiveOutlined sx={{ fontSize: '1.4rem' }} />
                                        </IconButton>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                        <Box mb={4}>
                            <Divider />
                        </Box>
                        {children}
                    </Box>
                )}
            </Drawer>
            <ModalDelete open={openModal} handleClose={handleClose} handleAction={handleAction} />
        </>
    );
};

export default DrawerViewEdit;